<!--
 - notifications
Displays toast-like notifications to the user.
Uses a global event bus to listen to these messages
Currently supports only 1 simultaneous message
-->
<template>
  <div>
    <transition name="g-animation-slide-in-left">
      <v-message
        :type="globalMessage.type"
        :affixed="true"
        v-if="globalMessage.show"
        :closeButton="hideGlobalMessage"
        data-test="global-notification">
        <icon slot="icon" :name="globalMessage.icon"></icon>
        <span slot="text" v-html="globalMessage.message"></span>
      </v-message>
    </transition>
  </div>
</template>
<script>
import { VMessage } from '@signable/ui-kit/src/atoms/';

export default {
  name: 'VNotifications',
  components: {
    VMessage,
  },
  data() {
    return {
      globalMessage: {
        show: false,
        message: '',
        type: 'info',
      },
    };
  },
  created() {
    this.$bus.$on('renderGlobalMessage', ({ message, icon, type }) => {
      this.globalMessage.show = false;
      setTimeout(() => {
        this.globalMessage.show = true;
        this.globalMessage.message = message;
        this.globalMessage.icon = icon;
        this.globalMessage.type = type;
      }, 200);
      setTimeout(() => {
        this.globalMessage.show = false;
      }, 5200);
    });
    this.$bus.$on('hideGlobalMessage', () => {
      this.globalMessage.show = false;
      this.globalMessage.message = '';
    });
  },
  methods: {
    // TODO - this function isn't used. Copied from App.vue when moving out.
    hideGlobalMessage() {
      this.$bus.$emit('hideGlobalMessage');
    },
  },
};
</script>
